export default __webpack_public_path__ + "static/media/addedProducts.c249cde6.png";